import _get from 'lodash/get'

export const get_talent_search = state => _get(state, 'talent.talent_search')
export const get_talent_event = state => _get(state, 'talent.talent_event')
